var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32.000000pt",
    height: "32.000000pt",
    viewBox: "0 0 32.000000 32.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,32.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 247 c-26 -27 -28 -54 -6 -85 14 -20 14 -23 -1 -28 -27 -11 -58 -84 -35 -84 6 0 10 7 10 15 0 26 47 65 78 65 35 0 72 37 72 71 0 32 -38 69 -71 69 -14 0 -35 -10 -47 -23z m82 -13 c31 -30 9 -84 -34 -84 -24 0 -50 26 -50 50 0 24 26 50 50 50 10 0 26 -7 34 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 125 c-3 -9 -12 -12 -22 -8 -13 5 -16 3 -11 -10 4 -10 0 -20 -11 -27 -16 -9 -16 -11 0 -20 11 -7 15 -17 11 -27 -5 -12 -2 -15 10 -10 10 4 20 0 27 -11 9 -16 11 -16 20 0 7 11 17 15 27 11 12 -5 15 -2 10 10 -4 10 0 20 11 27 16 9 16 11 0 20 -11 7 -15 17 -11 27 5 13 2 15 -11 10 -10 -4 -19 -1 -22 8 -4 8 -10 15 -14 15 -4 0 -10 -7 -14 -15z m39 -55 c0 -18 -6 -26 -23 -28 -24 -4 -38 18 -28 44 3 9 15 14 28 12 17 -2 23 -10 23 -28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 70 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashAdmin);
export default __webpack_public_path__ + "static/media/dash_admin.1940ec487d41ad927a03facca4a60b0c.svg";
export { ForwardRef as ReactComponent };